import { wordService } from "../services/wordService";

export const applyTitle = () => wordService.applySemanticTag({ type: "title", styleBuiltIn: "Title" });
